import React, { useEffect, useState } from "react";
import {
  Col,
  DatePicker,
  Form,
  InputNumber,
  Modal,
  Row,
  message,
} from "antd";
import dayjs from "dayjs";
import { addVitalsMonitoringApi } from "../../../../services/nurse.services";
import { vitalValidations } from "../../../../helpers/medicineKeys";


const FIELDS = [
  { label: "Temperature (°F)", name: "temperature" },
  { label: "Pulse Rate", name: "pulse" },
  { label: "Respiratory Rate", name: "respiration" },
  { label: "SPO2", name: "oxygen_saturation" },
  { label: "Systolic Pressure", name: "systolic_pressure" },
  { label: "Diastolic Pressure", name: "diastolic_pressure" },
  { label: "GRBS", name: "grbs" },
  { label: "Insulin", name: "insulin" },
];

const AddVitalsModal = ({ open, setOpen, admissionId, onSaved }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    form.resetFields();
    form.setFieldsValue({ action_time: dayjs() });
  }, [open, form]);

  const onFinish = (values) => {
    if (!admissionId) {
      message.error("No admission selected.");
      return;
    }
    const { action_time, ...readings } = values;
    const entered = Object.entries(readings).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    );
    if (!entered.length) {
      message.error("Enter at least one reading.");
      return;
    }

    setSaving(true);
    addVitalsMonitoringApi(admissionId, {
      ...Object.fromEntries(entered),
      action_time: dayjs(action_time || undefined).format("YYYY-MM-DDTHH:mm:ss"),
    })
      .then((res) => {
        message.success(res?.data?.message || "Vitals recorded.");
        setOpen(false);
        onSaved?.();
      })
      .catch((err) =>
        message.error(
          err?.response?.data?.message || "Failed to record vitals."
        )
      )
      .finally(() => setSaving(false));
  };

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      title="Add Vitals Record"
      okText="Save"
      onOk={() => form.submit()}
      confirmLoading={saving}
      width={620}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Date & Time"
          name="action_time"
          rules={[{ required: true, message: "Pick the time of the reading" }]}
        >
          <DatePicker
            showTime={{ format: "hh:mm A" }}
            format="DD MMM YYYY hh:mm A"
            style={{ width: "100%" }}
            disabledDate={(current) => current && current > dayjs().endOf("day")}
          />
        </Form.Item>
        <Row gutter={16}>
          {FIELDS.map((field) => {
            const range = vitalValidations[field.name];
            return (
              <Col xs={24} sm={12} key={field.name}>
                <Form.Item
                  label={field.label}
                  name={field.name}
                  rules={
                    range
                      ? [
                          {
                            type: "number",
                            min: range.minimum,
                            max: range.maximum,
                            message: `Enter ${range.minimum} to ${range.maximum}`,
                          },
                        ]
                      : undefined
                  }
                >
                  {/* The range is shown in the box rather than waiting for a
                      rejected value to reveal it. */}
                  <InputNumber
                    style={{ width: "100%" }}
                    placeholder={
                      range ? `${range.minimum} - ${range.maximum}` : undefined
                    }
                  />
                </Form.Item>
              </Col>
            );
          })}
        </Row>
      </Form>
    </Modal>
  );
};

export default AddVitalsModal;
